/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Team_Member_Removed_AuditInputs */

const en_team_member_removed_audit = /** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Team member removed: ${i?.name}`)
};

const es_team_member_removed_audit = /** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miembro del equipo eliminado: ${i?.name}`)
};

const fr_team_member_removed_audit = /** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membre de l'équipe retiré : ${i?.name}`)
};

const de_team_member_removed_audit = /** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teammitglied entfernt: ${i?.name}`)
};

const id_team_member_removed_audit = /** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anggota tim dihapus: ${i?.name}`)
};

/** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */
const ja_team_member_removed_audit = en_team_member_removed_audit;

/** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */
const zh_team_member_removed_audit = en_team_member_removed_audit;

/** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */
const ar_team_member_removed_audit = en_team_member_removed_audit;

/** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */
const it_team_member_removed_audit = en_team_member_removed_audit;

/** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */
const ru_team_member_removed_audit = en_team_member_removed_audit;

/** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */
const pt_team_member_removed_audit = en_team_member_removed_audit;

/** @type {(inputs: Team_Member_Removed_AuditInputs) => LocalizedString} */
const ko_team_member_removed_audit = en_team_member_removed_audit;

/**
* | output |
* | --- |
* | "Team member removed: {name}" |
*
* @param {Team_Member_Removed_AuditInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_member_removed_audit = /** @type {((inputs: Team_Member_Removed_AuditInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Member_Removed_AuditInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_member_removed_audit(inputs)
	if (locale === "es") return es_team_member_removed_audit(inputs)
	if (locale === "fr") return fr_team_member_removed_audit(inputs)
	if (locale === "de") return de_team_member_removed_audit(inputs)
	if (locale === "ja") return ja_team_member_removed_audit(inputs)
	if (locale === "zh") return zh_team_member_removed_audit(inputs)
	if (locale === "ar") return ar_team_member_removed_audit(inputs)
	if (locale === "id") return id_team_member_removed_audit(inputs)
	if (locale === "it") return it_team_member_removed_audit(inputs)
	if (locale === "ru") return ru_team_member_removed_audit(inputs)
	if (locale === "pt") return pt_team_member_removed_audit(inputs)
	return ko_team_member_removed_audit(inputs)
});